import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { FaEnvelope } from "react-icons/fa"
import * as styles from "../styles/staff.module.scss"

const Staff = props => (
  <section className={styles.leadership}>
      {props.display && (
        <header>
          <h2>{props.title}</h2>
        </header>
      )}    <div className="container">
      {props.staff.map(el => (
        <div className={styles.leader} key={el.id}>
          <div className={styles.imgContainer}>
            {console.log(el.picture.gatsbyImageData)}
          <GatsbyImage
              image={el.picture.gatsbyImageData}
              alt={el.picture.description}
              imgStyle={{ objectPosition: "top center" }}
            />
          </div>
          <div className={styles.leaderDescription}>
            <h3>{el.name}</h3>
            <h4>{el.role}</h4>
            <div className={styles.icons}>
              {el.email !== null && (
                <a href={`mailto:${el.email}`} aria-label={`${el.name} email`}>
                  <FaEnvelope />{el.email}
                </a>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
)

export default Staff
